// IE対応用
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

// Axios 1.15対応用
import 'url-polyfill';
import 'abortcontroller-polyfill';
import 'fast-text-encoding'; // ←これを追加

// ライブラリ
import bootstrap from 'bootstrap';